import { SAMLResponse } from "admin/src/server/bll/sso-config/saml/getSAMLResponse";
import { SSOConfigView } from "admin/src/server/mappers/sso-config/sso-config";

export const processSSOResponse = async (
  ssoResponse?: SAMLResponse,
  ssoConfig?: SSOConfigView,
): Promise<unknown> => {
  if (ssoConfig?.ssoSAMLConfig) {
    const formData = new FormData();

    ssoResponse?.signedAssertionString &&
      formData.append("SAMLResponse", ssoResponse?.signedAssertionString);

    if (ssoConfig?.ssoSAMLConfig?.consumerUrl) {
      return fetch(ssoConfig?.ssoSAMLConfig?.consumerUrl, {
        method: "POST",
        body: formData,
      });
    }
  }
};
